module.exports = __webpack_public_path__ + "img/sixpackcarrier62.5eb9cf7d.jpg";